module.exports = __webpack_public_path__ + "static/media/over50_premium_contract1.46d8c522.webp";